<script>
  export default {
    name: 'card-feature',
    props: {
      cardProps: {
        type: Object,
        default: () => ({})
      },
      cardActionsProps: {
        type: Object,
        default: () => ({})
      },
      cardTextProps: {
        type: Object,
        default: () => ({})
      },
      cardTitleProps: {
        type: Object,
        default: () => ({})
      },
      imgProps: {
        type: Object,
        default: () => ({})
      },
      imageSrc: {
        type: String,
        required: false
      },
      titleText: {
        type: String,
        required: false
      }
    },
    data: () => ({
      cardDefaults: {
        hover: true
      },
      titleDefaults: {
        class: 'px-2 primary--text'
      }
    }),
    computed: {
      imgHeight() {
        const heights = {
          xs: 240,
          sm: 300,
          md: 300,
          lg: 350,
          xl: 350
        }
        return heights[this.$vuetify.breakpoint.name]
      }
    }
  }
</script>
<template>
  <v-card
    v-bind="{ ...cardDefaults, ...cardProps }"
    :height="$vuetify.breakpoint.xs ? 'auto' : '100%'"
    max-width="600px"
    min-width="400px"
    rounded="lg"
    min-height="100%"
    width="100%"
    class="p-relative d-flex flex-column secondary ma-1"
  >
    <v-img v-if="imageSrc" v-bind="{ ...imgProps }" :src="imageSrc" cover :height="imgHeight" :max-height="imgHeight" width="100%"></v-img>

    <v-card-title v-if="titleText" v-html="titleText" v-bind="{ ...titleDefaults, ...cardTitleProps }" class="text-h5 text-sm-h4 font-weight-bold justify-center break-word">
    </v-card-title>
    <v-card-text v-bind="{ ...cardTextProps }" class="flex-grow-1">
      <slot name="card-text"></slot>
    </v-card-text>
    <v-card-actions v-bind="cardActionsProps">
      <slot name="card-actions"></slot>
    </v-card-actions>
  </v-card>
</template>

<style scoped>
  /* .image {
    height: 100%;
    max-height: 200px;
    width: 100%;
  } */

  .title {
    white-space: nowrap;
  }
</style>
